/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceConfigurationItemDto } from "./DeviceConfigurationItemDto";
import {
    DeviceConfigurationItemDtoFromJSON,
    DeviceConfigurationItemDtoFromJSONTyped,
    DeviceConfigurationItemDtoToJSON,
} from "./DeviceConfigurationItemDto";

/**
 *
 * @export
 * @interface DeviceConfigurationExtendedItemDto
 */
export interface DeviceConfigurationExtendedItemDto {
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    componentName?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    componentInstance?: string;
    /**
     *
     * @type {number}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    connectorId?: number;
    /**
     *
     * @type {number}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    physicalPlugId?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    variableName?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    variableInstance?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    unit?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    dataType?: string;
    /**
     *
     * @type {number}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    minLimit?: number;
    /**
     *
     * @type {number}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    maxLimit?: number;
    /**
     *
     * @type {number}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    maxElements?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    valuesList?: string;
    /**
     *
     * @type {boolean}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    supportsMonitoring?: boolean;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    description?: string;
    /**
     *
     * @type {Array<DeviceConfigurationItemDto>}
     * @memberof DeviceConfigurationExtendedItemDto
     */
    attributes?: Array<DeviceConfigurationItemDto>;
}

/**
 * Check if a given object implements the DeviceConfigurationExtendedItemDto interface.
 */
export function instanceOfDeviceConfigurationExtendedItemDto(
    value: object,
): value is DeviceConfigurationExtendedItemDto {
    return true;
}

export function DeviceConfigurationExtendedItemDtoFromJSON(
    json: any,
): DeviceConfigurationExtendedItemDto {
    return DeviceConfigurationExtendedItemDtoFromJSONTyped(json, false);
}

export function DeviceConfigurationExtendedItemDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConfigurationExtendedItemDto {
    if (json == null) {
        return json;
    }
    return {
        componentName:
            json["componentName"] == null ? undefined : json["componentName"],
        componentInstance:
            json["componentInstance"] == null
                ? undefined
                : json["componentInstance"],
        connectorId:
            json["connectorId"] == null ? undefined : json["connectorId"],
        physicalPlugId:
            json["physicalPlugId"] == null ? undefined : json["physicalPlugId"],
        variableName:
            json["variableName"] == null ? undefined : json["variableName"],
        variableInstance:
            json["variableInstance"] == null
                ? undefined
                : json["variableInstance"],
        unit: json["unit"] == null ? undefined : json["unit"],
        dataType: json["dataType"] == null ? undefined : json["dataType"],
        minLimit: json["minLimit"] == null ? undefined : json["minLimit"],
        maxLimit: json["maxLimit"] == null ? undefined : json["maxLimit"],
        maxElements:
            json["maxElements"] == null ? undefined : json["maxElements"],
        valuesList: json["valuesList"] == null ? undefined : json["valuesList"],
        supportsMonitoring:
            json["supportsMonitoring"] == null
                ? undefined
                : json["supportsMonitoring"],
        description:
            json["description"] == null ? undefined : json["description"],
        attributes:
            json["attributes"] == null
                ? undefined
                : (json["attributes"] as Array<any>).map(
                      DeviceConfigurationItemDtoFromJSON,
                  ),
    };
}

export function DeviceConfigurationExtendedItemDtoToJSON(
    value?: DeviceConfigurationExtendedItemDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        componentName: value["componentName"],
        componentInstance: value["componentInstance"],
        connectorId: value["connectorId"],
        physicalPlugId: value["physicalPlugId"],
        variableName: value["variableName"],
        variableInstance: value["variableInstance"],
        unit: value["unit"],
        dataType: value["dataType"],
        minLimit: value["minLimit"],
        maxLimit: value["maxLimit"],
        maxElements: value["maxElements"],
        valuesList: value["valuesList"],
        supportsMonitoring: value["supportsMonitoring"],
        description: value["description"],
        attributes:
            value["attributes"] == null
                ? undefined
                : (value["attributes"] as Array<any>).map(
                      DeviceConfigurationItemDtoToJSON,
                  ),
    };
}
